module.exports = __webpack_public_path__ + "static/img/freshman-python__en-hover.90eaa0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/freshman-python__en-hover.png
// module id = XEYl
// module chunks = 1